const CAT_4_MIN_DIMENSION_MM = 1200;
const FLAT_ROOF_TYPES = ["flat_glass", "dome", "lantern"];

export const CAT_4_OVERRIDE_OPTIONS = [
    { label: "Automatic (use dimensions)", value: "auto" },
    { label: "Always Cat 4", value: "cat4" },
    { label: "Never Cat 4", value: "not_cat4" },
];

export const cat4OverrideFromAPI = (value) =>
    value === true ? "cat4" : value === false ? "not_cat4" : "auto";

export const cat4OverrideToAPI = (option) =>
    option === "cat4" ? true : option === "not_cat4" ? false : null;

export const isFlatRoof = (productType) => FLAT_ROOF_TYPES.includes(productType);

export const cat4FromDimensions = (width, height) => {
    if (!(width > 0 && height > 0)) {
        return { isCat4: true, reason: "Dimensions missing, treated as Cat 4" };
    }

    const largest = Math.max(width, height);

    return largest >= CAT_4_MIN_DIMENSION_MM
        ? {
              isCat4: true,
              reason: `Largest side ${largest}mm is ${CAT_4_MIN_DIMENSION_MM}mm or more`,
          }
        : {
              isCat4: false,
              reason: `Largest side ${largest}mm is under ${CAT_4_MIN_DIMENSION_MM}mm`,
          };
};

export const isCat4 = ({ productType, override, width, height }) => {
    if (!isFlatRoof(productType)) return false;

    const forced = cat4OverrideToAPI(override);
    if (forced !== null) return forced;

    return cat4FromDimensions(width, height).isCat4;
};
